import { styled } from "@mui/material";

export const CircleIcon = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: 14,
  height: 14,
  border: `2px solid ${theme.palette.footer.link}`,
  borderRadius: '50%',
  position: 'relative',
  // margin-inline-end يدعم RTL و LTR أو يمكنك استخدام marginRight/Lef حسب الحاجة
  marginInlineEnd: 8,
  '&::after': {
    content: '""',
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.palette.footer.link,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));